export default __webpack_public_path__ + "static/media/logo_favicon_urgently.31bd30e3.svg";